import script from "./base-select-dropdown.vue?vue&type=script&setup=true&lang=ts&generic=Item%20extends%20SelectItem%2C%20Multiple%20extends%20boolean%20%3D%20false"
export * from "./base-select-dropdown.vue?vue&type=script&setup=true&lang=ts&generic=Item%20extends%20SelectItem%2C%20Multiple%20extends%20boolean%20%3D%20false"

const cssModules = {}
import style0 from "./base-select-dropdown.vue?vue&type=style&index=0&id=32ef167e&module=true&lang=css"
cssModules["$style"] = style0
/* custom blocks */
import block0 from "./base-select-dropdown.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__